export const QUESTION_PAGE_SIZE = 100;
export const MAX_SHARED_QUESTIONS = 20000;
export const QUESTION_FILTER_KEYS = [
  "scope", "q", "knowledge_area", "system_context", "competency", "status",
  "visibility", "tag", "observed_difficulty", "observed_quality", "usage", "sort", "exam_key",
];

export function questionShareFilters(filters) {
  return Object.fromEntries(QUESTION_FILTER_KEYS.flatMap((key) => {
    const value = typeof filters?.[key] === "string" ? filters[key].trim() : "";
    const textFilter = key === "q" || key === "tag";
    return value && (textFilter || value !== "all") ? [[key, value]] : [];
  }));
}

export function questionFilterKey(filters) {
  return JSON.stringify(questionShareFilters(filters));
}

export function questionPageQuery(filters, page) {
  return new URLSearchParams({
    page: String(page), page_size: String(QUESTION_PAGE_SIZE), summary: "true", ...questionShareFilters(filters),
  }).toString();
}

export function isSharedReadOnly(question) {
  return question?.read_only_shared === true ||
    (question?.access_scope === "shared" && question?.read_only_shared !== false);
}

export function canShareQuestion(question) {
  return question?.can_share === true && !isSharedReadOnly(question) &&
    typeof question.id === "string" && question.id.trim().length > 0;
}

export function shareablePageIds(questions) {
  return [...new Set(questions.filter(canShareQuestion).map((question) => question.id))];
}

export function updateQuestionSelection(selected, ids, checked) {
  const next = new Set(selected);
  ids.forEach((id) => checked ? next.add(id) : next.delete(id));
  if (next.size > MAX_SHARED_QUESTIONS) {
    throw new Error("O limite é de 20.000 questões por liberação. Refine os filtros ou reduza a seleção.");
  }
  return next;
}

export function readShareSelection(data) {
  const ids = data?.question_ids;
  if (!Array.isArray(ids) || ids.length > MAX_SHARED_QUESTIONS ||
      ids.some((id) => typeof id !== "string" || !id.trim()) || new Set(ids).size !== ids.length ||
      ![data.count, data.matching_count, data.skipped_count].every((count) => Number.isSafeInteger(count) && count >= 0) ||
      data.count !== ids.length || data.matching_count !== data.count + data.skipped_count) {
    throw new Error("Não foi possível validar a seleção completa. Atualize os filtros e tente novamente.");
  }
  return { ids: [...ids], matchingCount: data.matching_count, skippedCount: data.skipped_count };
}

export function readShareRecipients(data) {
  if (!Array.isArray(data?.items)) throw new Error("Não foi possível carregar a lista de professores.");
  const seen = new Set();
  return data.items.map((teacher) => {
    if (typeof teacher?.id !== "string" || !teacher.id.trim() || seen.has(teacher.id) ||
        typeof teacher.name !== "string" || !teacher.name.trim() ||
        !Array.isArray(teacher.school_names) || teacher.school_names.some((name) => typeof name !== "string")) {
      throw new Error("Não foi possível validar a lista de professores. Tente novamente.");
    }
    seen.add(teacher.id);
    return { id: teacher.id, name: teacher.name, school_names: [...teacher.school_names] };
  });
}
